import React, {useState} from 'react'
import ImgUploader from 'Components/Input/ImgUploader';
import {deleteImageCDN, validateFiles} from 'Utils/media'
import {Root} from 'Root'
import Button from "react-bootstrap/esm/Button";

const EditProfilePic = ({session, refreshSession, loading, setLoading}) => {
    const [errorMessage, setErrorMessage] = useState(null)
    const [uploadErrors, setUploadErrors] = useState([])

    function onError() {
        setErrorMessage('Error saving changes, please try again')
        setLoading(false)
    }

    function uint8ArrayToBase64(uint8Array) {
        let binary = '';
        const len = uint8Array.byteLength;
        for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(uint8Array[i]);
        }
        return btoa(binary);
    }

    function onDrop(event) {
        setLoading(true)
        if (event.target.files.length > 0) {
            setErrorMessage(null)
            setUploadErrors([])
            const errors = validateFiles(event.target.files, 5242880, ['.jpg', '.png', '.jpeg', '.gif'])
            if (Object.keys(errors).length > 0) {
                setUploadErrors(errors)
                setLoading(false)
                return
            }

            if (session.photo) {
                const prevImage = session.photo.split('/')[2];
                deleteImageCDN(prevImage)
            }

            event.target.files[0].arrayBuffer()
                .then((buffer) => {
                    Root.userApi.updateProfilePhoto(uint8ArrayToBase64(new Uint8Array(buffer)), event.target.files[0].type, session.jwt)
                        .then((res) => {
                            refreshSession(prevState => ({...prevState, photo: res.data}))
                            setLoading(false)
                        })
                        .catch((err) => {
                            onError()
                        })
                })
        }
    }

    const removePhoto = () => {
        Root.userApi.removeProfilePhoto(session.jwt)
            .then(() => {
                refreshSession()
                setLoading(false)
            })
            .catch((err) => {
                onError()
            })
    }

    return <div>
        <ImgUploader buttonClassName='d-block mx-auto btnLink'
                     buttonText={loading ? 'Uploading...' : (session.photo ? 'Update profile photo' : 'Add profile photo (We support GIFs!)')}
                     onDrop={onDrop}/>
        {session.photo &&
            <div style={{width: '100%', display: 'flex', justifyContent: 'space-around'}}>
                <Button className={'btnLink red m-auto p-0'} onClick={removePhoto}>Remove Photo</Button>
            </div>
        }
        {errorMessage && <p style={{textAlign: 'center', margin: 0}} className='form-error'>{errorMessage}</p>}
        {uploadErrors.map((error, idx) => {
            return <p key={idx} className='form-error' style={{textAlign: 'center', margin: 0}}>{error.type}</p>
        })}
    </div>
}

export default (EditProfilePic);